import { gql } from '@apollo/client';

// Fragment-only module, with no component or heavy-library imports, so the global
// fragment registry can register this fragment without pulling the booking view, and the charts it reaches, into the
// boot-time entry chunk.
export const VISIT_AVAILABILITY_FRAGMENT = gql`
    fragment VisitAvailability on Availability {
        potentialAppointmentAssignments {
            clinician {
                id
                firstName
                lastName
            }
            clinicianAppointmentId
        }
        timeOptions {
            start
            end
        }
        timezone
    }
`;
